import styles from "./InputField.module.css";
import {
    formatNumber,
    unformatNumber,
} from "../../services/numberFormatter";

const InputField = ({

    id,

    name,

    label,

    icon,

    value = "",

    placeholder = "",

    type = "text",

    inputMode,

    format,

    suffix,

    error,

    touched,

    hint,

    required = false,

    disabled = false,

    children,

    onChange,

    onBlur,

}) => {

    const hasError = Boolean(error && touched);

    const displayValue = (() => {

        switch (format) {

            case "number":
                return formatNumber(value);

            default:
                return value ?? "";

        }

    })();

    const handleChange = (e) => {

        let newValue = e.target.value;
    
        if (format === "number") {
    
            newValue = unformatNumber(newValue);
    
            // فقط عدد مجاز است
            if (!/^\d*$/.test(newValue)) {
                return;
            }
    
        }
    
        onChange({
            ...e,
            target: {
                ...e.target,
                id,
                name,
                value: newValue,
            },
        });
    
    };

    return (

        <div
            className={`${styles.wrapper} ${
                hasError
                    ? styles.error
                    : ""
            }`}
        >

            <div className={styles.label}>

                {

                    icon &&

                    <span className={styles.icon}>

                        {icon}

                    </span>

                }

                <span>

                    {label}

                    {

                        required &&

                        <small>*</small>

                    }

                </span>

            </div>

            <div className={styles.inputWrapper}>

                {

                    type === "select"

                        ? (

                            <select

                                id={id}

                                name={name}

                                value={value}

                                disabled={disabled}

                                onChange={handleChange}

                                onBlur={onBlur}

                                className={styles.input}

                            >

                                {children}

                            </select>

                        )

                        : (

                            <input

                                id={id}

                                name={name}

                                type={type}

                                value={displayValue}

                                placeholder={placeholder}

                                disabled={disabled}

                                inputMode={inputMode}

                                onChange={handleChange}

                                onBlur={onBlur}

                                className={styles.input}

                            />

                        )

                }

                {

                    suffix &&

                    <span className={styles.suffix}>

                        {suffix}

                    </span>

                }

            </div>

            {

                hint &&

                !hasError &&

                <div className={styles.hint}>

                    {hint}

                </div>

            }

            {

                hasError &&

                <div className={styles.errorText}>

                    {error}

                </div>

            }

        </div>

    );

};

export default InputField;